export default __webpack_public_path__ + "static/media/g_wdt_c_3.850b29c3.mp3";